// A saved historical label belongs to this form opening, not the active catalog.
export const orderSizeOptions = (activeSizes, historicalSize) => (
  typeof historicalSize === 'string' && historicalSize.trim() && !activeSizes.includes(historicalSize)
    ? [...activeSizes, historicalSize]
    : activeSizes
);
